const updates = [
  {
    date: '2026-07-30',
    title: '七月内容精选合集正式上线',
    desc: '本月最受欢迎的影视、综艺、纪录片内容已整理收录，可在主题导航中快速浏览。',
    tag: '内容更新',
  },
  {
    date: '2026-07-28',
    title: '短剧频道新增五个热门系列',
    desc: '短剧合集频道扩充内容库，新增都市情感、悬疑推理等多个系列的高品质短剧。',
    tag: '频道扩充',
  },
  {
    date: '2026-07-25',
    title: '移动端访问体验全面优化',
    desc: '针对手机浏览器进行了页面适配升级，加载速度提升40%，浏览更加流畅。',
    tag: '平台升级',
  },
  {
    date: '2026-07-22',
    title: '知识科普频道新增纪录片推荐',
    desc: '编辑团队精选了20部自然科学与人文历史类高分纪录片，已加入频道索引。',
    tag: '内容更新',
  },
  {
    date: '2026-07-18',
    title: '动漫频道同步七月新番追更表',
    desc: '七月开播的新番动漫全部收录完毕，追番日历已更新至最新状态。',
    tag: '追更提醒',
  },
  {
    date: '2026-07-15',
    title: '用户反馈通道正式开放',
    desc: '通过联系我们页面可提交内容建议与使用反馈，编辑团队将逐一回复处理。',
    tag: '功能上线',
  },
  {
    date: '2026-07-12',
    title: '体育频道新增赛事回放功能入口',
    desc: '近期热门体育赛事的完整回放与精彩集锦已按赛事分类整理，方便查找。',
    tag: '频道扩充',
  },
  {
    date: '2026-07-08',
    title: '首页导航结构优化调整',
    desc: '重新梳理了首页各模块的布局与导航链接，核心频道入口更加直观易用。',
    tag: '平台升级',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            最新动态
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            平台内容更新与功能迭代一手掌握
          </p>
        </div>
        <div className="relative pl-6 md:pl-8 border-l-2 border-primary-200 space-y-6">
          {updates.map((item, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[25px] md:-left-[29px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></div>
              <div className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200 cursor-default">
                <div className="flex flex-wrap items-center gap-2 mb-2">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-bold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}